module.exports = __webpack_public_path__ + "media/images/purple-pin-b2f3261e73a78071c847e22fb825a68d.png";